import { MailCheck } from 'lucide-react';
import { verifyEmailUrl } from '@/lib/emailVerification';

interface EmailUnverifiedNoticeProps {
  email: string | null | undefined;
}

/**
 * Shown instead of a generic error when the API refuses partner invitations because the
 * account's email is not confirmed. The button sends the user to RsConnect to confirm it.
 */
export function EmailUnverifiedNotice({ email }: EmailUnverifiedNoticeProps) {
  const href = verifyEmailUrl(import.meta.env.VITE_IDP_ISSUER_URL, email);

  return (
    <div
      role="status"
      className="flex items-start gap-3 rounded-lg border border-primary/30 bg-primary/5 px-4 py-3 dark:bg-primary/10"
    >
      <MailCheck className="mt-0.5 h-5 w-5 flex-shrink-0 text-primary" />
      <div className="space-y-2">
        <p className="text-[14px] font-semibold text-dark dark:text-dark-text">
          Bekræft din email for at se dine invitationer
        </p>
        <p className="text-[13px] leading-snug text-muted dark:text-dark-muted">
          Invitationer er knyttet til din emailadresse. Når du har bekræftet den, kan du se dem her.
        </p>
        {href && (
          <a
            href={href}
            className="inline-flex items-center rounded-md bg-primary px-3 py-1.5 text-[13px] font-medium text-white hover:bg-primary-700"
          >
            Bekræft email
          </a>
        )}
      </div>
    </div>
  );
}
